import React, { useContext } from 'react';
import Container from 'atomic/container';
import WidgetProductBoxItem from './widget-product-box-item/widget-product-box-item';
import WidgetProductBoxProps from './widget-product-box.props';
import { TeApiContext } from '@ecommerce/nest-ssr/common';
import classNames from 'classnames';

import './widget-product-box.scss';

const WidgetProductBox: React.FC<WidgetProductBoxProps> = props => {
    const api = useContext(TeApiContext);

    if (api === null) {
        throw new Error('Invalid API context');
    }

    const isMobile = api.getDevice() === 'mobile';
    const { items } = props.data;

    return (
        <Container className="w-product-box">
            <div className="w-product-box__container">
                {items.map((product, index) => (
                    <WidgetProductBoxItem
                        className={classNames({
                            'd-none': isMobile && (index % 2) === 0 && items.length === index + 1
                        })}
                        key={product.id}
                        product={product}
                        loading={index < 2 ? 'eager' : 'lazy'}
                    />
                ))}
            </div>
        </Container>
    );
};

export default WidgetProductBox;
